import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatUsageMinutes, normalizeUsageMinutes } from '../../../lib/utils/formatUsage';

const MonthlyMinutesBar = ({ used = 0, total = 0 }) => {
  const { t } = useTranslation();
  const displayTotal = normalizeUsageMinutes(total, total);
  const displayUsed = normalizeUsageMinutes(used, total);

  return (
    <div className="text-left sm:text-right">
      <div className="text-lg md:text-xl font-semibold text-foreground">
        {formatUsageMinutes(displayUsed)} / {formatUsageMinutes(displayTotal)}
      </div>
      <div className="text-xs md:text-sm text-muted-foreground">{t('ai.monthlyMinutes')}</div>
    </div>
  );
};

export default MonthlyMinutesBar;
